// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"28b32146","239":"506dbbb3","301":"a30606af","455":"4a8db12a","762":"6d0a0004"}[chunkId] + ".chunk.js";
};